import Invoicing from './Invoicing'
import { dateTimeFormat } from '@/utility/utility_functions'
import State from './State'
import moment from 'moment'

export default class Customer {
  constructor (id, created, modified, email, alternateEmail, website, firstName, lastName, phoneNumber, mobileNumber, personNumber, customerId, userId, postalAddress, postalCode, city, country, commune, additionalCommunes, invoicing, invoiceCustomerId, invoiceCustomerName, invoiceInformationMismatch, organisationName, organisationId, publicCertificates, previousLogin, lastLogin, county, needsInvoiceInformationUpdate) {
    this.id = id
    this.created = created
    this.modified = modified
    this.email = email
    this.alternateEmail = alternateEmail
    this.website = website
    this.firstName = firstName
    this.lastName = lastName
    this.phoneNumber = phoneNumber
    this.mobileNumber = mobileNumber
    this.personNumber = personNumber
    this.customerId = customerId
    this.userId = userId
    this.postalAddress = postalAddress
    this.postalCode = postalCode
    this.city = city
    this.country = country
    this.commune = commune
    this.additionalCommunes = additionalCommunes
    this.invoicing = invoicing
    this.invoiceCustomerId = invoiceCustomerId
    this.invoiceCustomerName = invoiceCustomerName
    this.invoiceInformationMismatch = invoiceInformationMismatch
    this.organisationName = organisationName
    this.organisationId = organisationId
    this.publicCertificates = publicCertificates
    this.previousLogin = previousLogin
    this.lastLogin = lastLogin
    this.county = county
    this.needsInvoiceInformationUpdate = needsInvoiceInformationUpdate
  }

  static asCustomers (json) {
    return json.map(customer => {
      return Customer.asCustomer(customer)
    })
  }

  static asCustomer (json) {
    return new Customer(
      json.id,
      json.created ? dateTimeFormat(json.created) : '',
      json.modified ? dateTimeFormat(json.modified) : '',
      json.email,
      json.alternate_email,
      json.web_site,
      json.first_name,
      json.last_name,
      json.phone,
      json.mobile,
      json.person_number,
      json.customer_id,
      json.user_id,
      json.address ? json.address.postal_address : null,
      json.address ? json.address.postal_code : null,
      json.address ? json.address.postal_city : null,
      json.country,
      json.address ? json.address.commune : null,
      json.address ? json.address.additional_communes : null,
      json.invoice_information ? Invoicing.asInvoicing(json.invoice_information) : null,
      json.invoice_customer ? json.invoice_customer : null,
      json.invoice_customer_name ? json.invoice_customer_name : '',
      json.invoice_information_mismatch ? json.invoice_information_mismatch : null,
      json.organisation_name ? json.organisation_name : '',
      json.organisation ? json.organisation : null,
      json.show_certificates_publicly,
      json.previous_login ? dateTimeFormat(json.previous_login) : '',
      json.last_login ? dateTimeFormat(json.last_login) : '',
      json.county ? json.county : '',
      json.needs_invoice_information_update
    )
  }

  get customerInformationChangedThisSession () {
    return moment(this.lastLogin) <= moment(this.modified)
  }

  get shouldShowOldInformationAlert () {
    if (!this.previousLogin) {
      return false
    }
    let threeMonthsAgo = moment().subtract(3, 'months')
    if (moment(this.previousLogin) < threeMonthsAgo) {
      return !this.customerInformationChangedThisSession
    }
    return false
  }

  get fullName () {
    return [this.firstName, this.lastName].filter(Boolean).join(' ')
  }

  get communes () {
    return this.additionalCommunes.join(', ')
  }

  get shouldShowEmailGlnWarning () {
    return this.invoicing.shouldShowEmailGlnWarning
  }

  get organisationLink () {
    if (this.organisationId) {
      return {
        name: 'OrganisationCustomersListView',
        params: { organisationId: this.organisationId }
      }
    }
    return {
      name: '',
      params: {}
    }
  }

  get customerLink () {
    return { name: 'InvoicingView', params: { customerId: this.id } }
  }

  get isConnectedToInvoiceCustomer () {
    return !!this.invoiceCustomerId
  }

  get hasAdditionalCommunes () {
    return !!(this.additionalCommunes && this.additionalCommunes.length)
  }

  get publicCertificatesCell () {
    return {
      display: this.publicCertificates ? 'Yes' : 'No',
      level: this.publicCertificates ? State.SUCCESS : State.DANGER,
      custom_classes: ['tag-flex']
    }
  }

  get defaultCustomerKeys () {
    return ['firstName', 'lastName', 'personNumber', 'customerId', 'phoneNumber', 'mobileNumber', 'email', 'website', 'postalAddress', 'postalCode', 'city', 'publicCertificatesState']
  }
  updateCurrentCustomer (customer) {
    if (this.id !== customer.id) {
      throw new Error('Objects missmatch')
    }
    this.created = customer.created
    this.modified = customer.modified
    this.email = customer.email
    this.website = customer.website
    this.firstName = customer.firstName
    this.lastName = customer.lastName
    this.phoneNumber = customer.phoneNumber
    this.mobileNumber = customer.mobileNumber
    this.personNumber = customer.personNumber
    this.customerId = customer.customerId
    this.userId = customer.userId
    this.postalCode = customer.postalCode
    this.postalAddress = customer.postalAddress
    this.city = customer.city
    this.country = customer.country
    this.invoicing = customer.invoicing
    this.invoiceCustomerId = customer.invoiceCustomerId
    this.invoiceCustomerName = customer.invoiceCustomerName
    this.organisationName = customer.organisationName
    this.organisationId = customer.organisationId
  }
}
